const ContactType = `
  id
  name
  description
`;

export default ContactType;
